import { ReportCategory } from '@features/constructor/types';
import { z } from 'zod';
export var AboutBuildingSchema = z.object({
    name: z.string().min(1, 'Поле обязательно для заполнения'),
    region: z.string().min(1, 'Поле обязательно для заполнения'),
    buildingPurpose: z.string().min(1, 'Поле обязательно для заполнения'),
    buildingType: z.string().min(1, 'Поле обязательно для заполнения'),
    maxHeight: z
        .string()
        .min(1, 'Поле обязательно для заполнения')
        .refine(function (value) { return Number.isInteger(Number(value)); }, 'Значение должно быть целым числом')
        .refine(function (value) { return +value > 0; }, 'Значение должно быть больше нуля'),
    comfortClass: z.string().min(1, 'Поле обязательно для заполнения'),
    requirement: z.string().min(1, 'Поле обязательно для заполнения'),
    isFloorPlan: z.nativeEnum(ReportCategory),
    isBim: z.boolean(),
});
